import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import moment from 'moment-timezone'

import styles from './grid-left-header-date.css'

const GridLeftHeaderDate = ({ date, style, color, isOver, onRemove }) => (
  <div style={{ ...style, color }} styleName={isOver ? 'cell-hover' : 'cell-normal'}>
    <div styleName="date">
      {moment(date.date, 'YYYYMMDD').format('MMM D')}
    </div>
    <div styleName="weekday">
      {moment(date.date, 'YYYYMMDD').format('ddd')}
    </div>
    <div styleName="remove" onClick={onRemove}>x</div>
  </div>
)

GridLeftHeaderDate.propTypes = {
  color: PropTypes.string,
  date: PropTypes.object.isRequired,
  isOver: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  style: PropTypes.object.isRequired,
}

export default CSSModules(GridLeftHeaderDate, styles)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-left-header-date/grid-left-header-date.js
 **/